import React from "react";
import ModalBox from "../../components/modal/ModalBox";
import { Button } from "../../components/Button/Button";

export const ViewMore = ({ value, handleSeeMore, length = 15 }) => {
  return (
    <>
      {value ? (
        value.length > length ? (
          <>
            {value.slice(0, length)}
            {handleSeeMore ? (
              <span className="seeMore" onClick={() => handleSeeMore(value)}>
                ...view
              </span>
            ) : (
              ""
            )}
          </>
        ) : (
          value
        )
      ) : (
        "N/A"
      )}
    </>
  );
};

export const DescriptionModal = ({
  show,
  close,
  value,
  title = "About & Purpose",
  fontSize = "",
}) => {
  return (
    <ModalBox
      status={show}
      onClose={close}
      title={title}
      custom
      description={<strong className={`${fontSize}`}>{value}</strong>}
      customizedFooter={<Button onClick={close}>Close</Button>}
    />
  );
};
